/**
 * @file コンポーネント：パスワード変更モーダル DOM管理
 */

// ライブラリ読み込み
import React from "react";

// コンポーネント読み込み
import { Modal } from "~/src/components/projects/Modal";
import { InputText } from "~/src/components/uiparts/InputText";
import { List } from "~/src/components/uiparts/List";
import { Paragraph } from "~/src/components/uiparts/Paragraph";

// スタイル読み込み
import { StyledModal, StyledModalContent, StyledModalLabel } from "./style";

// Presenterを返す
export const Presenter = (props) => {
    // ローカライズデータ
    const localized = window.listLocalized;

    // ReactDOM
    return (
        <Modal
            buttonlist={[
                {
                    buttonType: "submit",
                    onClick: (e) => props.fnClickRecoverPassword(e),
                    text: localized["Label.RecoverPassword"],
                },
            ]}
            content={[
                <StyledModal key="modal">
                    <StyledModalContent>
                        <Paragraph
                            onColor="white"
                            text={
                                localized[
                                    "Label.ChangeInitialPasswordDescription"
                                ]
                            }
                        />
                        <List
                            fontSize="xSmall"
                            icon="&#xf069;"
                            iconWeight="bold"
                            list={[
                                <>
                                    {localized["Label.PasswordPolicy"]}
                                    <List
                                        fontSize="xSmall"
                                        list={[
                                            localized[
                                                "Label.PasswordMinLength"
                                            ],
                                            localized[
                                                "Label.PasswordPolicyType"
                                            ],
                                            localized[
                                                "Label.PasswordPolicyHistory"
                                            ],
                                        ]}
                                        listStyleType="disc"
                                        onColor="white"
                                    />
                                </>,
                            ]}
                            listStyleType="icon"
                            onColor="white"
                        />
                    </StyledModalContent>
                    {props.errorMessages.length !== 0 && (
                        <StyledModalContent>
                            {props.errorMessages.map((message, index) => (
                                <Paragraph
                                    fontSize="xSmall"
                                    key={index}
                                    paragraphType="error"
                                    text={message}
                                />
                            ))}
                        </StyledModalContent>
                    )}
                    <StyledModalContent>
                        <StyledModalLabel>
                            {localized["Label.NewPassword"]}
                        </StyledModalLabel>
                        <InputText
                            isWide={true}
                            minlength="8"
                            onKeyDown={(e) => props.fnPressEnter(e)}
                            placeholder={
                                localized["Label.NewPasswordPlaceholder"]
                            }
                            refInputText={props.refNewPassword}
                            type="password"
                        />
                    </StyledModalContent>
                    <StyledModalContent>
                        <StyledModalLabel>
                            {localized["Label.NewPasswordConfirm"]}
                        </StyledModalLabel>
                        <InputText
                            isWide={true}
                            minlength="8"
                            onKeyDown={(e) => props.fnPressEnter(e)}
                            placeholder={
                                localized["Label.NewPasswordPlaceholder"]
                            }
                            refInputText={props.refConfirmNewPassword}
                            type="password"
                        />
                    </StyledModalContent>
                </StyledModal>,
            ]}
            hasButtonClose={true}
            headline={localized["Label.ChangeInitialPassword"]}
            isShow={props.isOpenModalNewPassword}
            setIsShow={props.setIsOpenModalNewPassword}
        />
    );
};
